export default __webpack_public_path__ + "static/media/Section4-sub2.24a788c4.svg";